var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 69.058,
    viewBox: "0 0 200 69.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-bot-logo",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 80,
    height: 70,
    fill: "rgba(21,130,199,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M32.5,0A32.5,32.5,0,0,1,65,32.5V65H32.5a32.5,32.5,0,0,1,0-65Zm.488,3L32.5,3a29.5,29.5,0,0,0-.488,59l.488,0H62V32.5A29.5,29.5,0,0,0,33.469,3.016L32.988,3Z",
    fill: "#1581c6",
    stroke: "#1581c6",
    strokeLinejoin: "round",
    strokeWidth: 2.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(5.814 11.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M10.491,54.056H9.076a3.273,3.273,0,0,1-3.262-3.262V44.513a3.277,3.277,0,0,1,3.262-3.268h.916a20.756,20.756,0,0,0,.5,12.811Z",
    transform: "translate(-5.814 -24.976)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M90.771,44.513v6.281a3.273,3.273,0,0,1-3.262,3.262H85.894a20.756,20.756,0,0,0,.5-12.811h1.116A3.277,3.277,0,0,1,90.771,44.513Z",
    transform: "translate(-42.496 -24.976)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(3.929 1.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M33.17,14.555A20.111,20.111,0,1,0,53.281,34.666,20.107,20.107,0,0,0,33.17,14.555Zm0,35.361a15.253,15.253,0,1,1,15.255-15.25A15.251,15.251,0,0,1,33.17,49.916Z",
    transform: "translate(-13.064 -14.555)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M26.4,13.55a2.332,2.332,0,0,1-1.588,2.211v.824c-.509.379-1,.786-1.479,1.214V15.761A2.328,2.328,0,1,1,26.4,13.55Z",
    transform: "translate(-13.111 -11.225)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(20.429 27.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M50.456,62.921H43.782a.271.271,0,1,1,0-.542h6.674a.271.271,0,1,1,0,.542Z",
    transform: "translate(-43.511 -62.379)",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(28.039 17.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M58.095,47.6a.542.542,0,0,1-.383-.925l2.681-2.681a.542.542,0,0,1,.766.766l-2.681,2.681A.539.539,0,0,1,58.095,47.6Z",
    transform: "translate(-57.553 -43.83)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(28.039 17.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M60.776,47.6a.54.54,0,0,1-.383-.159l-2.681-2.681a.542.542,0,0,1,.766-.766l2.681,2.681a.542.542,0,0,1-.383.925Z",
    transform: "translate(-57.553 -43.83)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(15.549 17.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M35.048,47.6a.542.542,0,0,1-.383-.925l2.681-2.681a.542.542,0,0,1,.766.766l-2.681,2.681A.538.538,0,0,1,35.048,47.6Z",
    transform: "translate(-34.506 -43.83)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(15.549 17.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M37.729,47.6a.54.54,0,0,1-.383-.159l-2.681-2.681a.542.542,0,0,1,.766-.766l2.681,2.681a.542.542,0,0,1-.383.925Z",
    transform: "translate(-34.506 -43.83)",
    fill: "#333"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M25.68-36.78h0a8.009,8.009,0,0,0-6.99,3.66q-2.5,3.67-2.5,10.11h0q0,13.39,10.18,13.39h0a21.047,21.047,0,0,0,5.97-.85,59.539,59.539,0,0,0,5.81-2.07h0v10.6A32.161,32.161,0,0,1,25.01.63h0Q14.5.63,8.9-5.46T3.3-23.07h0A28.154,28.154,0,0,1,6.01-35.74a19.425,19.425,0,0,1,7.81-8.39A23.57,23.57,0,0,1,25.8-47.07h0A32.98,32.98,0,0,1,40.18-43.8h0l-3.84,9.87a44.409,44.409,0,0,0-5.14-2.03A18.061,18.061,0,0,0,25.68-36.78ZM78.52,0h-8.6L67.54-4.76h-.25A14.136,14.136,0,0,1,62.18-.51,16.95,16.95,0,0,1,55.45.63h0a10.57,10.57,0,0,1-8-3.04q-2.92-3.05-2.92-8.57h0q0-5.75,4-8.55t11.58-3.16h0l6-.19v-.51q0-4.44-4.38-4.44h0q-3.93,0-10,2.66h0l-3.58-8.19q6.28-3.23,15.87-3.23h0q6.92,0,10.71,3.42t3.79,9.59h0ZM60.72-8.13h0a5.6,5.6,0,0,0,3.85-1.42,4.756,4.756,0,0,0,1.6-3.72h0v-2.79l-2.85.13q-6.13.22-6.13,4.5h0Q57.19-8.13,60.72-8.13ZM99.44-35.96V0H87.03V-35.96ZM86.71-44.91h0a5.265,5.265,0,0,1,1.55-4.16q1.56-1.36,5.02-1.36h0q3.46,0,5.05,1.39a5.228,5.228,0,0,1,1.58,4.13h0q0,5.46-6.63,5.46h0Q86.71-39.45,86.71-44.91Z",
    transform: "translate(-3.3 50.43)",
    fill: "#1582c7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(5 57.06)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 9.66,
    height: 1,
    transform: "translate(0 3.58)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 9.66,
    height: 1,
    transform: "translate(76.95 3.58)",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M4.43-3.2H2.06l.38-1.2c.14-.44.28-.88.4-1.32s.26-.88.38-1.34h.04c.13.46.26.91.39,1.34s.26.88.41,1.32Zm.25.8L5.42,0H6.49L3.83-7.87H2.7L.04,0H1.06l.75-2.4Zm2.95.68-.6.7a3.813,3.813,0,0,0,1.23.85A3.7,3.7,0,0,0,9.79.14a3.255,3.255,0,0,0,1.12-.17,2.639,2.639,0,0,0,.84-.48,2.037,2.037,0,0,0,.53-.71,2.05,2.05,0,0,0,.19-.88,1.985,1.985,0,0,0-.13-.76A1.97,1.97,0,0,0,12-3.44a2.209,2.209,0,0,0-.52-.43,6.25,6.25,0,0,0-.63-.33L9.73-4.68a4.84,4.84,0,0,1-.47-.21,2.959,2.959,0,0,1-.42-.26,1.243,1.243,0,0,1-.3-.35.937.937,0,0,1-.12-.49.989.989,0,0,1,.41-.84,1.651,1.651,0,0,1,1.06-.31,2.4,2.4,0,0,1,.99.2,2.822,2.822,0,0,1,.8.54l.54-.64a3.27,3.27,0,0,0-1.02-.71,3.166,3.166,0,0,0-1.31-.27,3.113,3.113,0,0,0-.99.16,2.292,2.292,0,0,0-.78.44,2.2,2.2,0,0,0-.52.66,1.968,1.968,0,0,0-.18.83,1.81,1.81,0,0,0,.14.76,2.076,2.076,0,0,0,.37.57,2.3,2.3,0,0,0,.52.41,6.014,6.014,0,0,0,.56.29l1.13.49c.18.09.36.17.52.25a2.08,2.08,0,0,1,.41.27,1.1,1.1,0,0,1,.28.36,1.286,1.286,0,0,1,.1.51,1.149,1.149,0,0,1-.43.93A1.868,1.868,0,0,1,9.8-.73,2.748,2.748,0,0,1,8.62-1,3.234,3.234,0,0,1,7.63-1.72Zm6.24,0-.6.7a3.813,3.813,0,0,0,1.23.85,3.7,3.7,0,0,0,1.53.31,3.255,3.255,0,0,0,1.12-.17,2.639,2.639,0,0,0,.84-.48,2.037,2.037,0,0,0,.53-.71,2.05,2.05,0,0,0,.19-.88,1.985,1.985,0,0,0-.13-.76,1.97,1.97,0,0,0-.34-.58,2.209,2.209,0,0,0-.52-.43,6.25,6.25,0,0,0-.63-.33l-1.12-.48a4.84,4.84,0,0,1-.47-.21,2.959,2.959,0,0,1-.42-.26,1.243,1.243,0,0,1-.3-.35.937.937,0,0,1-.12-.49.989.989,0,0,1,.41-.84,1.651,1.651,0,0,1,1.06-.31,2.4,2.4,0,0,1,.99.2,2.822,2.822,0,0,1,.8.54l.54-.64a3.27,3.27,0,0,0-1.02-.71,3.166,3.166,0,0,0-1.31-.27,3.113,3.113,0,0,0-.99.16,2.292,2.292,0,0,0-.78.44,2.2,2.2,0,0,0-.52.66,1.968,1.968,0,0,0-.18.83,1.81,1.81,0,0,0,.14.76,2.076,2.076,0,0,0,.37.57,2.3,2.3,0,0,0,.52.41,6.014,6.014,0,0,0,.56.29l1.13.49c.18.09.36.17.52.25a2.08,2.08,0,0,1,.41.27,1.1,1.1,0,0,1,.28.36,1.286,1.286,0,0,1,.1.51,1.149,1.149,0,0,1-.43.93,1.868,1.868,0,0,1-1.22.36A2.748,2.748,0,0,1,14.86-1,3.234,3.234,0,0,1,13.87-1.72Zm6.39-6.15V0h.99V-7.87Zm3.18,6.15-.6.7a3.77,3.77,0,0,0,1.22.85A3.718,3.718,0,0,0,25.6.14a3.235,3.235,0,0,0,1.11-.17,2.639,2.639,0,0,0,.84-.48,2.2,2.2,0,0,0,.54-.71,2.2,2.2,0,0,0,.18-.88,2.2,2.2,0,0,0-.12-.76,2,2,0,0,0-.35-.58,2.154,2.154,0,0,0-.51-.43,5.487,5.487,0,0,0-.64-.33l-1.11-.48a3.958,3.958,0,0,1-.47-.21,2.959,2.959,0,0,1-.42-.26,1.282,1.282,0,0,1-.31-.35,1.043,1.043,0,0,1-.11-.49.981.981,0,0,1,.4-.84,1.67,1.67,0,0,1,1.06-.31,2.4,2.4,0,0,1,.99.2,2.822,2.822,0,0,1,.8.54l.54-.64A3.27,3.27,0,0,0,27-7.75a3.166,3.166,0,0,0-1.31-.27,3.113,3.113,0,0,0-.99.16,2.292,2.292,0,0,0-.78.44,2.024,2.024,0,0,0-.51.66,1.836,1.836,0,0,0-.19.83,1.981,1.981,0,0,0,.14.76,1.9,1.9,0,0,0,.38.57,2.241,2.241,0,0,0,.51.41,5.1,5.1,0,0,0,.57.29l1.12.49c.19.09.36.17.52.25a1.822,1.822,0,0,1,.41.27,1.1,1.1,0,0,1,.28.36,1.132,1.132,0,0,1,.1.51,1.121,1.121,0,0,1-.43.93,1.839,1.839,0,0,1-1.21.36A2.715,2.715,0,0,1,24.43-1,3.234,3.234,0,0,1,23.44-1.72Zm7.77-5.31V0h1.01V-7.03H34.6v-.84H28.84v.84ZM38.88-3.2H36.52l.37-1.2c.14-.44.28-.88.41-1.32s.25-.88.37-1.34h.05c.12.46.25.91.38,1.34s.26.88.41,1.32Zm.25.8L39.88,0h1.06L38.28-7.87H37.15L34.49,0h1.02l.75-2.4Zm2.93-5.47V0h.95V-4.12c0-.41-.02-.83-.04-1.24s-.06-.82-.09-1.22h.04l.86,1.62L46.63,0h1.03V-7.87h-.94V-3.8c0,.41.01.83.04,1.26s.05.84.08,1.24h-.05l-.85-1.63L43.09-7.87Zm7.31,3.93a5.2,5.2,0,0,0,.26,1.73,3.709,3.709,0,0,0,.72,1.28,3.085,3.085,0,0,0,1.09.8,3.453,3.453,0,0,0,1.37.27,2.947,2.947,0,0,0,1.35-.3A3.477,3.477,0,0,0,55.21-1l-.56-.61a3.171,3.171,0,0,1-.81.65,2.138,2.138,0,0,1-1,.23,2.252,2.252,0,0,1-1.02-.23,2.149,2.149,0,0,1-.76-.65,3.276,3.276,0,0,1-.49-1.01,5.008,5.008,0,0,1-.17-1.34,4.483,4.483,0,0,1,.18-1.32,3.125,3.125,0,0,1,.5-1,2.271,2.271,0,0,1,.78-.64,2.308,2.308,0,0,1,1.02-.22,1.945,1.945,0,0,1,.89.2,2.652,2.652,0,0,1,.69.53l.56-.63a3.128,3.128,0,0,0-.89-.68,2.553,2.553,0,0,0-1.26-.3,3.439,3.439,0,0,0-1.4.29,3.118,3.118,0,0,0-1.11.81,3.9,3.9,0,0,0-.73,1.28A5.277,5.277,0,0,0,49.37-3.94Zm7.31-3.93V0h4.65V-.85H57.67V-3.71h2.99v-.85H57.67V-7.03h3.54v-.84Z",
    transform: "translate(-0.1 9)",
    stroke: "#000",
    strokeWidth: 0.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotLogo);
export default __webpack_public_path__ + "static/media/chat-bot-logo.1a26fabd7bc4fb141d2cf549ac69c228.svg";
export { ForwardRef as ReactComponent };